<template>
  <div>
    <ts-card>
      <div
        class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative"
      >
        <h4 class="ts-text-sm"></h4>
        <ts-modal-close-button />
      </div>
      <br />
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal">
            <fieldset>
              <legend class="text-blue">Upload File</legend>
              <div class="row">
                <div class="col-md-2">
                  <label class="col-label form-label ts-ml-3 mt-2">{{
                    $t('thesis.submetesDate')
                  }}</label>
                </div>
                <div class="col-md-6">
                  <ts-date-picker-input
                    v-model="model.submitted_date"
                    style="width: 300px"
                  >
                  </ts-date-picker-input>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-md-12">
                  <div
                    class="ts-w-full ts-border-2 ts-border-dashed ts-rounded-md ts-p-4"
                  >
                    <div
                      class="ts-flex ts-w-full ts-items-center ts-justify-center ts-space-x-2"
                    >
                      <Fileview
                        v-for="(file, index) in model.attached_doc"
                        :key="index"
                        :file="file"
                        :index="index"
                        v-model="model"
                      />
                      <div
                        @click="onClickBrowse"
                        class="ts-w-32 ts-h-32 ts-rounded-md ts-flex ts-items-center ts-justify-center ts-bg-gray-300 ts-p-2 ts-cursor-pointer hover:ts-bg-gray-400 ts-duration-150 ts-transition-all"
                      >
                        <i class="fas fa-paperclip fa-2x"></i>
                      </div>
                    </div>
                    <input
                      class="ts-hidden"
                      type="file"
                      ref="fileInput"
                      multiple
                      @change="onFileBrowseChange"
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </form>
          <div class="ts-text-right mt-3">
            <ts-button @click.prevent="$emit('close')">
              {{ $t('cancel') }}
            </ts-button>
            <ts-button
              class="btn btn-primary ml-2"
              :waiting="waiting_save"
              @click.prevent="onSubmit"
              >{{ $t('save') }}</ts-button
            >
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import moment from 'moment'
import Fileview from './file-view.vue'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'attachedFile',
  components: {
    Fileview
  },
  data: function () {
    return {
      loading: false,
      waiting_save: false,
      fileChange: false,
      model: {
        attached_doc: [],
        submitted_date: moment().format('DD-MM-YYYY'),
        thesis_reg_id: null,
        student_id: null
      }
    }
  },
  computed: {
    ...mapState('thesis', ['editData'])
  },
  created () {
    this.setEditData()
  },
  methods: {
    onClickBrowse () {
      this.$refs.fileInput.click()
    },
    onFileBrowseChange (event) {
      const files = event.target.files
      for (let file of files) {
        this.model.attached_doc.push({
          file: file,
          name: file.name,
          type: file.type,
        })
      }
    },
    async onSubmit () {
      this.waiting_save = true
      this.errors = new Errors()
      let formData = new FormData()
      formData.append('student_id', this.model.student_id)
      formData.append('thesis_reg_id', this.model.thesis_reg_id)
      formData.append('submitted_date', this.model.submitted_date)
      this.model.attached_doc.forEach(file => {
        formData.append('attached_doc[]', file.file)
      })
      this.$store
        .dispatch('thesis/attachFile', formData)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$emit('fetchData')
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting_save = false
        })
      // on success clear value
      this.$refs.fileInput.value = ''
    },
    setEditData () {
      this.model.thesis_reg_id = this.editData.thesis_reg_id
    }
  }
}
</script>
